module.exports = __webpack_public_path__ + "media/src/ui/icons/iconReply-b47edc6a37368fe054594363739dee1a.png";